/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { useAlert } from '../../../Common/hooks';
import { getReasonFilters } from '../../selectors';
import { getReasonReports } from '../../services';
import { reasonsError } from '../../constants';

const useReasonReport = () => {
  const filters = useSelector(getReasonFilters);
  const { showAlert } = useAlert();
  const [reasonReports, setReasonReports] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const handleFilterChange = async () => {
    if (filters.aggregatorID && filters.payerID) {
      setIsLoading(true);
      const { reasonCodes, status } = await getReasonReports(filters);
      if (status === 404) {
        showAlert({ color: 'error', icon: 'exclamation', message: reasonsError });
      }

      setReasonReports(reasonCodes);
      setIsLoading(false);
    } else {
      setReasonReports([]);
    }
  };

  useEffect(() => {
    handleFilterChange();
  }, [filters]);

  return {
    reasonReports,
    isLoading,
  };
};

export default useReasonReport;
